import React from 'react'
import pipe from 'lodash/fp/pipe'
import { makeStyles } from '@material-ui/styles'
import { domToReact } from 'html-react-parser'
import Section from 'tcweb-material-components/core/section'
import keys from 'tcweb-material-components/core/poly/keys'
import reduce from 'tcweb-material-components/core/poly/reduce'
import camelCase from 'tcweb-material-components/core/poly/camelCase'
import get from 'tcweb-material-components/core/poly/get'
import classnames from 'classnames'

import { cleanWPValue } from '../../utilities/wpOptions'

const getFlexStyle = (data) => ({
    flexDirection: data.direction,
    justifyContent: data.justifyContent,
    alignItems: data.alignItems
})

const getSpacingStyle = (prefix, path, data) => pipe(
    keys,
    reduce((styles, key) => ({
        ...styles,
        [camelCase([prefix, key])]: cleanWPValue(get(data, [prefix, path, key]))
    }), {})
)(get(data, [prefix, path], {}))

const useClasses = makeStyles(theme => ({
    boxSwap: ({ data, backgroundColor }) => ({
        backgroundColor: !!backgroundColor ? backgroundColor : 'initial',
        display: 'flex',
        width: cleanWPValue(get(data, 'size.mobile.width')),
        height: cleanWPValue(get(data, 'size.mobile.height')),
        ...getFlexStyle(get(data, 'flex.mobile', {})),
        ...getSpacingStyle('padding', 'mobile', data),
        ...getSpacingStyle('margin', 'mobile', data),
        [theme.breakpoints.up('sm')]: {
            width: cleanWPValue(get(data, 'size.tablet.width')),
            height: cleanWPValue(get(data, 'size.tablet.height')),
            ...getFlexStyle(get(data, 'flex.tablet', {})),
            ...getSpacingStyle('padding', 'tablet', data),
            ...getSpacingStyle('margin', 'tablet', data),
        },
        [theme.breakpoints.up('md')]: {
            width: cleanWPValue(get(data, 'size.desktop.width')),
            height: cleanWPValue(get(data, 'size.desktop.height')),
            ...getFlexStyle(get(data, 'flex.desktop', {})),
            ...getSpacingStyle('padding', 'desktop', data),
            ...getSpacingStyle('margin', 'desktop', data),
        }
    })
}))

const BoxSwap = ({ attribs, children, options, data, classes = {}, className, itemMargins, ...rest }) => {
    const _classes = useClasses({ data, backgroundColor: get(attribs, "data-background-color") })

    const hasCustomGradient = attribs?.style ? `${attribs.style.toString().split(':')[1]}`: null

    return (
        <Section
            {...rest}
            itemMargins={{
                ...itemMargins,
                mobile: get(data, 'space.mobile.between'),
                tablet: get(data, 'space.tablet.between'),
                desktop: get(data, 'space.desktop.between')
            }}
            className={classnames(
                'box-swap',
                _classes.boxSwap,
                classes.root,
                className,
                `bg-${get(data, 'background.mobile.type')}`,
                get(attribs, 'class')
            )}
            style={{background: hasCustomGradient}}
        >
            {rest.isSubSection ? children : domToReact(children, options)}
        </Section>
    )
}


export default BoxSwap
